<template>
	<section class="non-chrome-alert">
		<modal
			modalTitle="Important"
			class="md social-share-modal disable-padding"
			v-if="showModal"
			cancelBtnName="Dismiss"
			@close="browserWarningDismissed()"
		>
			<div class="text-modal-copy" slot="modalContent">
				<p class="description-content">
					For the best experience using Brand 360, we recommend that you use
					<a href="https://www.google.com/chrome/" target="_blank"
						>Google Chrome</a
					>.
				</p>
			</div>
		</modal>
	</section>
</template>

<script>
import Modal from '@/components/global/Modal.vue';

export default {
	name: 'nonChromeAlert',
	components: {
		Modal,
	},
	props: {
		showModal: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		browserWarningDismissed() {
			this.showModal = false;
			localStorage.setItem('browserWarningDismissed', 'true');
		},
	},
};
</script>

<style lang="scss" scoped>
.description-content {
	@include rem(margin-left, 15px);
}

a {
	color: $brand-blue;
}
</style>
